<template>
    <div v-if="visible" class="lightbox" @click.self="close">

        <div class="lightbox__content">
            <button class="lightbox__nav left" @click.stop="prev">‹</button>

            <img :src="currentImage" class="lightbox__image" />

            <button class="lightbox__nav right" @click.stop="next">›</button>
        </div>

        <div class="lightbox__actions">
            <button
                class="lightbox__btn"
                @click="close"
            >
                ✕ Close
            </button>

            <a
                class="lightbox__btn"
                :href="currentImage"
                download
            >
                ⬇ Download
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Lightbox',
    props: {
        images: { type: Array, required: true },
        index: { type: Number, default: 0 },
        visible: { type: Boolean, default: false },
    },
    computed: {
        currentImage() {
            return this.images[this.index]
        },
    },
    watch: {
        visible(val) {
            if (val) {
                window.addEventListener('keydown', this.handleKey)
            } else {
                window.removeEventListener('keydown', this.handleKey)
            }
        },
    },
    methods: {
        close() {
            this.$emit('update:visible', false)
        },
        next() {
            if (this.index < this.images.length - 1) {
                this.$emit('update:index', this.index + 1)
            } else {
                this.$emit('update:index', 0)
            }
        },
        prev() {
            if (this.index > 0) {
                this.$emit('update:index', this.index - 1)
            } else {
                this.$emit('update:index', this.images.length - 1)
            }
        },
        handleKey(e) {
            if (e.key === 'Escape') this.close()
            if (e.key === 'ArrowRight') this.next()
            if (e.key === 'ArrowLeft') this.prev()
        },
    },
}
</script>

<style scoped>
.lightbox {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.85);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.lightbox__content {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}

.lightbox__image {
    width: 60vw;
    height: 70vh;
    max-width: 900px;
    max-height: 700px;
    object-fit: contain;
    border-radius: 6px;
    display: block;
}

.lightbox__nav {
    background: transparent;
    color: white;
    font-size: 50px;
    padding: 20px;
    border: none;
    cursor: pointer;
    user-select: none;
}

.lightbox__nav.left {
    margin-right: 20px;
}

.lightbox__nav.right {
    margin-left: 20px;
}

.lightbox__actions {
    position: absolute;
    bottom: 30px;
    right: 40px;
    display: flex;
    gap: 12px;
}

.lightbox__btn {
    color: white;
    font-size: 16px;
    text-decoration: none;
    padding: 8px 16px;
    border: 1px solid white;
    border-radius: 6px;
    background: transparent;
    cursor: pointer;
}

.lightbox__btn:hover {
    background: rgba(255, 255, 255, 0.1);
}
</style>
